export const maskedNumber = (value: string | number) => {
	const stringValue = (value || '')?.toString();
	return stringValue.replace(/.(?=.{4})/g, '*');
};

export const maskedDot = (value: string | number) => {
	const stringValue = (value || '')?.toString();
	return `**** **** **** ${stringValue}`;
};
